export const DbDataChangedNotificationDtoTypeValues = [
    'BiathlonPicture',
    'Category',
    'CommunicationToApprove',
    'ContestantAndRaceContestantTime',
    'DeviceEvent',
    'DeviceStation',
    'DeviceStatusStation',
    'EventImplementation',
    'Eventinfo',
    'EventinfoBase',
    'EventinfoSearchlistItem',
    'EventInfoSelectLine',
    'EventLocation',
    'EventNameDateId',
    'EventSetup',
    'EventTeam',
    'FocusEvent',
    'Group',
    'GroupWithCount',
    'HeatPlan',
    'ManagerReport',
    'MatrixShootingCellWarningsAcknowledgement',
    'Participant',
    'Race',
    'RaceContestantComplete',
    'RaceContestantDetails',
    'RankedTime',
    'Report',
    'ReportParameter',
    'ResultSetup',
    'SignupSettings',
    'StartingNumber',
    'StartnumberDbStateModel',
    'Station',
    'StationDetails',
    'StationRole',
    'UserRole',
] as const;
export type DbDataChangedNotificationDtoType = (typeof DbDataChangedNotificationDtoTypeValues)[number];
